import axios from "axios";
import CryptoJS from "crypto-js"; // Import CryptoJS for HMAC-SHA256 signature generation

// Secret key (keep this on the backend for better security if possible)
const SECRET_KEY =
  "469e0123d9170f18a13deb7391603cf9d6b2bb788fe0623ad5a1013038918bed";

// Create an axios instance
const api = axios.create({
  baseURL: "https://thebrokerz.com/api", // Laravel backend API URL
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  withCredentials: true, // Required for cookies or sessions
});

// Add Bearer Token and Security Headers to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("access_token"); // Retrieve token from localStorage

    // Add Authorization header if token is available
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }

    // Generate X-Timestamp and X-Signature for security
    const timestamp = Math.floor(Date.now() / 1000).toString(); // Current timestamp in seconds
    const requestBody = config.data ? JSON.stringify(config.data) : ""; // Convert request body to string (if available)
    const stringToSign = timestamp + requestBody;

    // Generate HMAC-SHA256 signature
    const signature = CryptoJS.HmacSHA256(stringToSign, SECRET_KEY).toString(
      CryptoJS.enc.Hex
    );

    // Add security headers
    config.headers["X-Timestamp"] = timestamp;
    config.headers["X-Signature"] = signature;

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor for potential error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      // Handle unauthorized access
      localStorage.removeItem("access_token"); // Clear token
      localStorage.removeItem("user"); // Clear user data
      window.location.href = "/sign-in"; // Redirect to sign-in page
    }
    return Promise.reject(error);
  }
);

export default api;
